module.exports = __webpack_public_path__ + "img/commune-avenches.3b6f202a.png";